import Vue from 'vue';

const storageName = 'vkb-2mk05';

export default {
  SET_INTERNSHIP_STATE (state, payload) {
    state.internshipState = {
      ...state.internshipState,
      ...payload
    };

    Vue.localStorage.set(storageName, JSON.stringify(state));
  },

  RESET_INTERNSHIP_STATE (state) {
    state.internshipState = {};
    Vue.localStorage.set(storageName, JSON.stringify(state));
  },

  ADD_TRACKING_DATA (state, payload) {
    state.trackingData = state.trackingData || [];
    state.trackingData.push(payload);

    Vue.localStorage.set(storageName, JSON.stringify(state));
  },

  RESET_TRACKING_DATA (state) {
    state.trackingData = [];

    Vue.localStorage.set(storageName, JSON.stringify(state));
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js